// extracted by mini-css-extract-plugin
export default {"modal":"modal-ui_modal__TNYuk","modal__content":"modal-ui_modal__content__n2F3u"};